import { Editor } from 'slate'

import { CustomEditor } from '../interface/custom-types'

import { isList, isListItem } from './listHelpers/isListHelper'

export const getListWrapOptions = (editor: CustomEditor) => {
  if (!editor.selection) {
    return
  }
  const [...liElements] = Editor.nodes(editor, { match: isListItem, at: editor.selection })

  return liElements.length > 1 ? { match: isList } : undefined
}
